// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compose-inscription-form__container {
    width: 100%;
    margin: auto;
    background-color: var(--white-color);
    padding: 30px 50px 30px 50px;
    overflow: auto;
}

.compose-inscription-form__container input[type=text], 
.compose-inscription-form__container .select-field-input, 
.compose-inscription-form__container .input-field-input {
    background-color: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    box-sizing: border-box;
    border-radius: 8px;
    width: 100%;
}
.compose-inscription-form__container .input-field-input, 
.compose-inscription-form__container .MuiTypography-body1, 
.compose-inscription-form__container p, 
.compose-inscription-form__container .input-field-label, 
.compose-inscription-form__container .select-field-label {
    font-size: 14px;
}

.compose-inscription-form__container form {
    display: flex;
    flex-direction: column;
}

.compose-inscription-form__container .input-field-label{
    font-weight: var(--font-regular);
    color: var(--primary-very-dark-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    
    .compose-inscription-form__container{
        /* padding-bottom: 20%; */
        padding: 0 16px;
        margin-bottom: 30px;
    }

    .compose-inscription-form__container .input-field-input, 
    .compose-inscription-form__container .MuiTypography-body1, 
    .compose-inscription-form__container p, 
    .compose-inscription-form__container .input-field-label, 
    .compose-inscription-form__container .select-field-label {
        font-size: var(--space);
    }
}

.compose-inscription-form__container__title{
    color: var(--primary-very-dark-color) !important;
    margin-bottom: var(--space-half);
}

.compose-inscription-form__container__error_message{
   display: flex;
   padding: var(--space-half);
   align-items: center;
   justify-content: space-between;
   background-color: #FEF6F6;
   border-radius: 4px;
   margin-bottom: var(--space);
}

.compose-inscription-form__container__error_message .baloa-body-1{
    color: var(--primary-very-dark-color) !important;
    padding-left: var(--space-half);
}

.compose-inscription-form__container__error_message img{
    width: 20px;
    height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/tournaments/components/compose-inscription-form/ComposeInscriptionFormComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;;;IAGI,oCAAoC;IACpC,kDAAkD;IAClD,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;AACf;AACA;;;;;IAKI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,qCAAqC;AACzC;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,yBAAyB;QACzB,eAAe;QACf,mBAAmB;IACvB;;IAEA;;;;;QAKI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,gDAAgD;IAChD,gCAAgC;AACpC;;AAEA;GACG,aAAa;GACb,0BAA0B;GAC1B,mBAAmB;GACnB,8BAA8B;GAC9B,yBAAyB;GACzB,kBAAkB;GAClB,2BAA2B;AAC9B;;AAEA;IACI,gDAAgD;IAChD,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".compose-inscription-form__container {\n    width: 100%;\n    margin: auto;\n    background-color: var(--white-color);\n    padding: 30px 50px 30px 50px;\n    overflow: auto;\n}\n\n.compose-inscription-form__container input[type=text], \n.compose-inscription-form__container .select-field-input, \n.compose-inscription-form__container .input-field-input {\n    background-color: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    box-sizing: border-box;\n    border-radius: 8px;\n    width: 100%;\n}\n.compose-inscription-form__container .input-field-input, \n.compose-inscription-form__container .MuiTypography-body1, \n.compose-inscription-form__container p, \n.compose-inscription-form__container .input-field-label, \n.compose-inscription-form__container .select-field-label {\n    font-size: 14px;\n}\n\n.compose-inscription-form__container form {\n    display: flex;\n    flex-direction: column;\n}\n\n.compose-inscription-form__container .input-field-label{\n    font-weight: var(--font-regular);\n    color: var(--primary-very-dark-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    \n    .compose-inscription-form__container{\n        /* padding-bottom: 20%; */\n        padding: 0 16px;\n        margin-bottom: 30px;\n    }\n\n    .compose-inscription-form__container .input-field-input, \n    .compose-inscription-form__container .MuiTypography-body1, \n    .compose-inscription-form__container p, \n    .compose-inscription-form__container .input-field-label, \n    .compose-inscription-form__container .select-field-label {\n        font-size: var(--space);\n    }\n}\n\n.compose-inscription-form__container__title{\n    color: var(--primary-very-dark-color) !important;\n    margin-bottom: var(--space-half);\n}\n\n.compose-inscription-form__container__error_message{\n   display: flex;\n   padding: var(--space-half);\n   align-items: center;\n   justify-content: space-between;\n   background-color: #FEF6F6;\n   border-radius: 4px;\n   margin-bottom: var(--space);\n}\n\n.compose-inscription-form__container__error_message .baloa-body-1{\n    color: var(--primary-very-dark-color) !important;\n    padding-left: var(--space-half);\n}\n\n.compose-inscription-form__container__error_message img{\n    width: 20px;\n    height: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
